(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grs-card-purchase"] && !Shopify.designMode) return;
  try {
    function updateCardPurchaseSelection(select) {
  const form = select.closest('.grs-card-purchase__form--variants');
  if (!form) return;
  const button = form.querySelector('.js_frm_cart');
  const option = select.selectedOptions[0];
  const ready = Boolean(option && option.value && !option.disabled);
  if (!button) return;
  button.disabled = !ready;
  button.classList.toggle('disabled', !ready);
  button.setAttribute('aria-disabled', String(!ready));
  if (!ready) return;
  const label = option.dataset.addLabel || button.querySelector('span').textContent;
  const title = form.dataset.productTitle || '';
  button.querySelector('span').textContent = label;
  button.setAttribute('aria-label', label + ': ' + title + ' — ' + option.dataset.variantTitle);
  const card = form.closest('.grs-product-card');
  if (!card) return;
  const price = card.querySelector('.grs-product-card__price');
  if (price && option.dataset.price) {
    const current = document.createElement('span');
    current.textContent = option.dataset.price;
    price.replaceChildren(current);
    if (option.dataset.onSale === 'true' && option.dataset.comparePrice) {
      const compare = document.createElement('s');
      compare.textContent = option.dataset.comparePrice;
      price.append(compare);
    }
  }
  const image = card.querySelector('.grs-product-card__image img');
  if (image && option.dataset.imageUrl) {
    image.removeAttribute('srcset');
    image.src = option.dataset.imageUrl;
    image.alt = title + ' — ' + option.dataset.variantTitle;
  }
}
document.addEventListener('change', function (event) {
  if (event.target instanceof Element && event.target.matches('.grs-card-purchase__select')) {
    updateCardPurchaseSelection(event.target);
  }
});
function initializeCardPurchaseSelections() {
  document.querySelectorAll('.grs-card-purchase__select').forEach(updateCardPurchaseSelection);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCardPurchaseSelections, { once: true });
} else {
  initializeCardPurchaseSelections();
}
window.addEventListener('pageshow', initializeCardPurchaseSelections);
document.addEventListener('click', function (event) {
  if (!(event.target instanceof Element)) return;
  const control = event.target.closest('.grs-card-purchase__button');
  if (control && control.classList.contains('loading')) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);
  } catch(e) { console.error(e); }
})();

})();
